var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-screen" },
    [
      _c("h2", { staticClass: "mb-4" }, [_vm._v("\n    Change Password\n  ")]),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "auth-block has-border" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-form-input", {
                    attrs: { type: "password", title: "New Password" },
                    model: {
                      value: _vm.newPassword,
                      callback: function($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex justify-content-end flex-no-wrap ml-3 mt-3"
                },
                [
                  !!_vm.error
                    ? _c(
                        "div",
                        {
                          staticClass: "mr-4 alert alert-danger fade show",
                          attrs: { role: "alert" }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.error) + "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ml-2 d-flex flex-nowrap align-content-end align-items-end"
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2 mr-2",
                          attrs: { title: "Cancel", disabled: _vm.loading },
                          on: { click: _vm.onCancel }
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            title: "Reset Password"
                          },
                          on: {
                            click: _vm.onSubmitChangeForm,
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              return _vm.onSubmitChangeForm($event)
                            }
                          }
                        },
                        [_vm._v("\n            Change Password\n          ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 d-flex" }, [
      _vm._v(
        "\n    Users are required to change their password from the initial password\n    created on account creation."
      ),
      _c("br")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }